import ReducerUtils   from "../../../utils/ReducerUtils"
import Actions        from "../../../model/constant/actions"

const RetrievingUsers = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVING_PACY_USERS] : (state,action)=>action.status
})

export default RetrievingUsers
